import { ArchiveMutation } from "../../hooks/useArchiveState";
import { RosTemplateControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * @author Atish Bagate
 */
export const useRosCarePlanTemplateArchive = () =>
  useMutationWithLoading(async (params: ArchiveMutation) =>
    new RosTemplateControllerApi(getConfigObject()).updateRosArchiveStatus(
      params?.id,
      params?.status,
      params?.xTENANTID
    )
  );
